import { useCallback } from 'react';

import { useIsInboxPanelOpen } from '@trello/split-screen';

import {
  addQuickCaptureNotifications,
  type QuickCaptureCard,
} from './quickCaptureNotificationsState';
import { useDismissQuickCaptureNotifications } from './useDismissQuickCaptureNotifications';
import { useIsQuickCaptureInboxNotificationsEnabled } from './useIsQuickCaptureInboxNotificationsEnabled';

export const useQuickCaptureNotificationsAddedToState = () => {
  const { value: isQuickCaptureInboxNotificationsEnabled } =
    useIsQuickCaptureInboxNotificationsEnabled();

  const inboxOpen = useIsInboxPanelOpen();
  const dismissQuickCaptureNotifications =
    useDismissQuickCaptureNotifications();

  const handleQuickCaptureNotifications = useCallback(
    (notifications: QuickCaptureCard[]) => {
      if (!inboxOpen) {
        addQuickCaptureNotifications(notifications);
      } else {
        dismissQuickCaptureNotifications();
      }
    },
    [dismissQuickCaptureNotifications, inboxOpen],
  );
  if (!isQuickCaptureInboxNotificationsEnabled) {
    return;
  }

  return handleQuickCaptureNotifications;
};
